import COMMON_ROUTE_PATHS from 'common/config/routes/route-paths';

const ROUTE_PATHS = {
  preload: '/deposit/:token',
  authentication: '/deposit/auth/:token',
  gateway: '/deposit/gateway/:token',
  manual: '/deposit/card/:token', // @TODO product
  selectMethod: '/deposit/select-method/:token',
  reverseSelectMethod: '/deposit/public/select-method/:token',
  walletSummary: '/deposit/wallet/summary/:token',
  walletAddFunds: '/deposit/wallet/add-funds/:token',
  paymentSummary: '/deposit/payment/summary/:token',
  cardSummary: '/deposit/card/summary/:token',
  subscriptionSummary: '/deposit/subscription/summary/:token',
  subscriptionCompletedPage: '/deposit/subscription/completed/:token',
  subscriptionSelectMethodPage: '/deposit/subscription/select-method/:token',
  profile: '/deposit/profile/:token',
  identityValidation: '/deposit/identity/validation/:token',
  waiting: '/deposit/waiting/:token',
  error: '/deposit/invalid/request',
  completed: '/deposit/completed/:token',
  pay: '/deposit/pay/:token',
  merchantRedirect: '/merchant_deposit',
  addCard: '/deposit/add-card/:token',
  selectCard: '/deposit/select-card/:token',
  checkoutPage: '/deposit/checkout/:token',
  ...COMMON_ROUTE_PATHS,
};

export default ROUTE_PATHS;
